import { useContext, createContext } from 'react';
import type {
    TProfitabilityType,
    IFeedCardAsset,
} from '@alfa-bank/site-invest-emitents-common/src/models';
import { PROFITABILITY_TYPE_DAY } from '@alfa-bank/site-invest-emitents-common/constants';

import type { IDetailCardAsset } from '../models';

interface ICardDataContext {
    card: IDetailCardAsset[];
    collapseHeight?: number;
    feed: IFeedCardAsset[];
    /**
     * Используется для критичных для SEO путей, которые могут вести на другой домен сайта.
     * Содержит текущий URI страницы + pathname: https://alfabank.com/make-money/investments/
     * Например находясь на alfabank.ru мы получим alfabank.com так как .com является master.
     * Всегда возвращает основной домен для SEO
     * */
    masterOriginPathnameUri: string;
    /**
     * Используется когда нужно получить origin + pathname текущей страницы для не критичных для SEO ссылок
     * Содержит текущий URI страницы + pathname: https://alfabank.ru/make-money/investments/
     * Находясь на alfabank.ru мы получим alfabank.ru, несмотря на то что masterOrigin будет alfabank.com
     * Находясь на alfabank.com мы получим alfabank.com
     * Всегда возвращает текущий домен
     * */
    originPathnameUri: string;
    profitabilityType: TProfitabilityType;
}

export const CardDataContext = createContext<ICardDataContext>({
    card: [],
    feed: [],
    originPathnameUri: '',
    masterOriginPathnameUri: '',
    profitabilityType: PROFITABILITY_TYPE_DAY,
});

export const useCardDataContext = () => useContext(CardDataContext);
